module.exports = __webpack_public_path__ + "img/hr-heat-pipe-corner-up-left-6.83aa30be.png";